<script lang="ts">
  import { getContext } from 'svelte';
  import { push } from 'svelte-spa-router';
  import Loading from '../../etc/loader.svelte';
  import BundleOptionChangeModal from '../../etc/modal/bundleoption/BundleOptionChangeModal.svelte';
  import MailIspChangeModal from '../../etc/modal/bundleoption/MailIspChangeModal.svelte';
  import RepositoryFactory, { CONTRACT, BUNDLE_OPTION } from '../../repositories/RepositoryFactory';
  import type { GetContractResult, GetSubContractListResult } from '../../repositories/contract';
  import type { GetBundleOptionDisplayListResult } from '../../repositories/bundleoption';
  import { loginUser } from '../../components/auth/LoginUser';

  const { open }: any = getContext('simple-modal');

  let contract: GetContractResult;
  let bundleOptionList: GetBundleOptionDisplayListResult[];
  let subContractList: GetSubContractListResult[];

  let promise = getApi();

  // 契約情報取得
  async function getApi() {
    const contractRepository = RepositoryFactory[CONTRACT];
    const bundleOptionRepository = RepositoryFactory[BUNDLE_OPTION];

    await Promise.all([
      contractRepository.getContract(),
      contractRepository.getSubContractList(),
      bundleOptionRepository.getBundleOptionDisplayList()
    ])
      .then((res) => {
        contract = res[0];
        subContractList = res[1];
        bundleOptionList = res[2];
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
        } else {
          alert('エラーが発生しました。');
        }
        return false;
      });

    return { contract, bundleOptionList };
  }

  const showBundleOptionModal = (id: number) => {
    open(BundleOptionChangeModal, {
      mstServiceId: id,
      serviceClass: contract.serviceClass
    });
  };
  const showMailIspModal = (id: number) => {
    open(MailIspChangeModal, { mstServiceId: id });
  };

  const isDisabledApply = (serviceCode: string, bundleOptionId: number) => {
    // 解約済みは押下不可
    if (contract.contractStatusCode === 'TERMINATED') {
      return true;
    }
    // すでに契約中の場合は押下可
    if (bundleOptionId) {
      return false;
    }
    // 上記以外の場合は「PC+Androidセキュリティ」と「光01メール」のみ押下可
    return serviceCode !== 'HIKARI01_PCANDROID' && serviceCode !== 'HIKARI01_MAIL_ISP';
  };

  const isMailIsp = (serviceCode: string) => {
    return serviceCode === 'HIKARI01_MAIL_ISP';
  };
</script>

{#await promise}
  <Loading />
{:then { contract, bundleOptionList }}
  {#each bundleOptionList as bundleOption}
    {#if bundleOption.displayOrder}
      <div class="inline-grid grid-cols-3 justify-items-center items-center p-4">
        <div class="grid-1 col-span-2 justify-self-start">
          <span class="inline-block font-semibold">
            {bundleOption.serviceName}
          </span>
        </div>
        <div class="grid-1">
          <button
            on:click={() => {
              isMailIsp(bundleOption.serviceCode)
                ? showMailIspModal(bundleOption.mstServiceId)
                : showBundleOptionModal(bundleOption.mstServiceId);
            }}
            class="button-primary"
            disabled={isDisabledApply(bundleOption.serviceCode, bundleOption.bundleOptionId)}
          >
            詳細
          </button>
        </div>
      </div>
    {/if}
  {/each}
{:catch error}
  <!-- API取得失敗 -->
{/await}

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default bg-gray-400;
  }
</style>
